import { useState } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DateObject from "react-date-object";
import useMediaQuery from "@mui/material/useMediaQuery";
import InputLabel from "@mui/material/InputLabel";
import Pagination from "@mui/material/Pagination";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import DialogData from "./OneTicketDialog/DialogData";
import OneTicketDetails from "./OneTicketDialog/OneTicketDetails";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function createData(name, data) {
  return { name, data };
}

// دیتاهای مورد نیاز و اسم نمایشی آنها را تعین میکند
const neededData = {
  // _id: "شناسه کد",
  // isFirstContent": "اول",
  title: "عنوان تیکت",
  ticketId: "شناسه تیکت",
  status: "وضعیت",
  createdAt: "تاریخ ایجاد تیکت",
};

export default function StudentsList(props) {
  const { fetchedTicketsList, pageAndPerPage, setNumberPageAndPerPage } = props;

  // اگر سایز صفحه از 600 پیکسل کوچکتر شود مقدار ترو برمیگرداند
  const detectSize600px = useMediaQuery("(min-width:600px)");
  const [openDialogContent, setOpenDialogContent] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("");
  const [dialogContentData, setDialogContentData] = useState("");

  const RecivedData = fetchedTicketsList["docs"];

  // let allStatusCodeState = {};
  // هر مجموعه از دیتا را برای هر جدول درون یک المنت آرایه از listOfTable میریزد
  let listOfTable = RecivedData.map((el, index) => {
    const rowOfTableData = [];
    rowOfTableData[0] = el;
    for (const property in el) {
      // دیتاهایی که در neededData گفته ایم نیاز داریم را جدا می کند
      if (neededData[property]) {
        // دیتاهایی که  بصورت تاریخ هستند - باید خودمان مشخص کنیم-. را تبدیل به تاریخ شمسی میکند
        if (property == "createdAt") {
          const date = new DateObject({
            date: el[property],
            calendar: persian,
            locale: persian_fa,
          });
          rowOfTableData.push(
            createData(neededData[property], {
              name: property,
              data: date.format(),
            })
          );
        } else
          rowOfTableData.push(
            createData(neededData[property], {
              name: property,
              data: el[property],
            })
          );
      }
    }
    return rowOfTableData;
  });

  const handleOpenDialogContent = () => {
    setOpenDialogContent(true);
  };
  const handleCloseDialogContent = () => {
    setOpenDialogContent(false);
  };

  //  فانکشنی برای نشان دادن پاپ آپ وابسته به کلیک بر روی دکمه های مختلف در جدول
  const setDialog = (type, dataContent) => {
    if (type == "getOneTicketDetails") {
      setDialogTitle(`${listOfTable[dataContent][0]["title"]}`);
      handleOpenDialogContent();
      setDialogContentData(
        <OneTicketDetails
          ticketId={listOfTable[dataContent][0]["ticketId"]}
          handleCloseDialogContent={handleCloseDialogContent}
        />
      );
    }
  };

  // اطلاعات هر سطر را بر میگرداند و در صورت نیاز قبل از برگرداندن تغیراتی روی دیتا انجام می دهیم
  const showRowData = (index, data, oneRow) => {
    const { name, data: content } = data;
    if (name == "status") {
      switch (content) {
        case "answerByUser":
          return <StyledTableCell align="left">پاسخ کاربر</StyledTableCell>;
        case "closeTicket":
          return <StyledTableCell align="left">بسته شده</StyledTableCell>;
        case "openTicket":
          return <StyledTableCell align="left">تیکت باز </StyledTableCell>;
        case "answerBySupoort":
          return (
            <StyledTableCell align="left">پاسخ پشتبانی سایت </StyledTableCell>
          );
        default:
          return <StyledTableCell align="left">نامشخص</StyledTableCell>;
      }
    } else {
      return <StyledTableCell align="left">{content}</StyledTableCell>;
    }
  };

  return (
    <>
      <DialogData
        openDialogContent={openDialogContent}
        handleCloseDialogContent={handleCloseDialogContent}
        dialogTitle={dialogTitle}
      >
        {dialogContentData}
      </DialogData>
      <Box>
        {listOfTable.map((oneRow, index) => (
          <TableContainer
            key={`MainTable-${index}`}
            component={Paper}
            sx={{ mb: 1 }}
          >
            <Table sx={{ minWidth: 10 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell
                    sx={{ width: detectSize600px ? "25%" : "50%" }}
                  ></StyledTableCell>
                  <StyledTableCell
                    sx={{ width: detectSize600px ? "75%" : "50%" }}
                    align="left"
                  ></StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {oneRow.map((row, indexrow) =>
                  indexrow == 0 ? (
                    <StyledTableRow key={`row-${indexrow}`}>
                      <StyledTableCell sx={{ m: 0, p: 0 }}>
                        <IconButton
                          sx={{ ml: 2 }}
                          aria-label="edit"
                          color="warning"
                          onClick={(e) => {
                            setDialog("getOneTicketDetails", index);
                          }}
                        >
                          <QuestionAnswerIcon />
                          <Typography sx={{ mx: 1 }}>مشاهده</Typography>
                        </IconButton>
                      </StyledTableCell>
                      <StyledTableCell align="left"></StyledTableCell>
                    </StyledTableRow>
                  ) : (
                    <StyledTableRow key={`MainTable-${index}-${row.name}`}>
                      <StyledTableCell component="th" scope="row">
                        {row.name}
                      </StyledTableCell>
                      {showRowData(index, row.data, oneRow)}
                    </StyledTableRow>
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>
        ))}
        <Box sx={{ display: "flex", alignItems: "baseline" }}>
          <Pagination
            count={pageAndPerPage.totalPages}
            siblingCount={0}
            color="primary"
            hideNextButton={pageAndPerPage.hasNextPage}
            hidePrevButton={pageAndPerPage.hasPrevPage}
            page={pageAndPerPage.page}
            onChange={(e, value) => {
              setNumberPageAndPerPage("page", value);
            }}
          />
          {pageAndPerPage.totalPages == 0 ? null : (
            <>
              تعداد کل:{pageAndPerPage.totalDocs}
              <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                <InputLabel id="demo-select-small">تعداد در هر صفحه</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  defaultValue={5}
                  value={pageAndPerPage.perPage}
                  label="تعداد در هر صفحه"
                  onChange={(e) => {
                    setNumberPageAndPerPage("perPage", e.target.value);
                  }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={35}>35</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </Select>
              </FormControl>
            </>
          )}
        </Box>
      </Box>
    </>
  );
}
